import { createContext, forwardRef, PureComponent, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const WindowSizeContext = createContext(null);

const updateWindowSize = () => ({
    height: window.innerHeight,
    width: window.innerWidth,
});

// DEPRECATED: Use CSS media queries (or shared/util/mobile).
export const WindowSizeProvider = ({ children }) => {
    const [windowSize, setWindowSize] = useState({ height: 0, width: 0 });
    const [isMobile, setIsMobile] = useState(true);

    useEffect(() => {
        const handleResize = () => {
            setWindowSize(updateWindowSize());
            setIsMobile(window.innerWidth < 768);
        };

        // Must refresh state on first client load before any resizing takes place,
        // otherwise a desktop user will ee the mobile view until the browser is resized manually.
        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return <WindowSizeContext.Provider value={{ ...windowSize, isMobile }}>{children}</WindowSizeContext.Provider>;
};

WindowSizeProvider.propTypes = {
    children: PropTypes.object.isRequired,
};

// DEPRECATED: Use CSS media queries (or shared/util/mobile).
export const useWindowSize = () => useContext(WindowSizeContext);

// DEPRECATED: Use CSS media queries (or shared/util/mobile).
export const withWindowSize = (mapDataToProps) => (WrappedComponent) => {
    class Wrapped extends PureComponent {
        render() {
            const { forwardedRef } = this.props;
            return (
                <WindowSizeContext.Consumer>
                    {(data) => <WrappedComponent {...this.props} {...mapDataToProps({ ...data })} ref={forwardedRef} />}
                </WindowSizeContext.Consumer>
            );
        }
    }

    Wrapped.propTypes = {
        forwardedRef: PropTypes.object,
    };

    return forwardRef((props, ref) => <Wrapped {...props} forwardedRef={ref} />);
};
